import SettlementSearch from "../SettlementSearch.model";
import SettlementService from "./../SettlementService";
import _ from "lodash";
import i18n from "../../../shared/i18n";
import {store} from "@/plugins/vuex";
import {SETTLEMENTS_TABLE_NAME} from "@/modules/constants";
import EventBus from "@/plugins/event-bus";
import {ON_SETTLEMENTS_TABLE_GET_TABLE_DATA} from "@/plugins/event-bus/event-bus-names";

import {
  SETTLEMENT_TYPE_AUCTION, SETTLEMENT_TYPE_AUCTION_INTRODUCTORY,
  SETTLEMENT_TYPE_DEBIT_NOTE,
  SETTLEMENT_TYPE_MANUAL,
  SETTLEMENT_TYPE_MANUAL_INTRODUCTORY
} from "../../constants";
import InvoicesService from "@/modules/invoices/InvoicesService";
import {hasPermission} from "@/core/directives/permission";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-settlement_no',
    search: '',
    searchModel: new SettlementSearch(),
    extraFilters: {},
    expand: [
      'receipts',
      'settlement_payments.payment.currency',
      'settlement_payments.payment.batch_payment',
      'settlement_payments.payment.beneficiary_relation.related_customer',
      'currency',
      'auction.currency',
      'customer.billing_address.country',
      'customer.identification',
      'total_financial_items',
      'debited_settlement',
      'settlement_payments.financial_export.created_by',
      'payable_amount',
      'settlement_payments.check_number',
      'settlement_payments.check_uuid',
      'settlement_payments.check_status',
      'settlement_payments.payee',
      'settlement_payments.batch_id',
      'settlement_payments.reference_number',
      'settlement_payments.bacs_uuid',
    ],
    toggleColumns: {
      fields: [...getDefaultFields(), ...differentFields],
      dynamicFields: [],
      requiredFields: ['customer_uuid'],
      defaultFields: ['settlement_no', 'type', 'sale_no', 'customer_uuid', 'amounts', 'total_items', 'status', 'actions'],
    }
  }
};

let getDefaultFields = () => {
  let fields = [
    {
      key: "settlement_no",
      label: i18n.t('No.'),
      sortable: true,
      tdClass: 'settlement-no-col',
      isVisible: true,
      expand: ''
    },
    {key: "type", label: i18n.t('Type'), sortable: true, tdClass: 'type-col', isVisible: true, expand: ''},
    {key: "sale_no", label: i18n.t('Sale'), sortable: true, tdClass: 'sale-no-col', isVisible: true, expand: ''},
    {
      key: "customer_uuid",
      label: i18n.t('Vendor'),
      sortable: true,
      tdClass: 'customer-uuid-col',
      isVisible: true,
      expand: 'customer'
    },
    {
      key: 'total_vendor_vat',
      label: i18n.t('Vendor VAT'),
      sortable: true,
      tdClass: 'vendor-vat-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "customer_company_name",
      label: i18n.t('Vendor Company'),
      sortable: true,
      tdClass: 'customer_company_name-col',
      isVisible: false,
      expand: 'customer'
    },
    {
      key: "amounts",
      label: i18n.t('Total / Paid / Outstanding'),
      sortable: false,
      tdClass: 'amounts-col',
      isVisible: true,
      expand: ''
    },
    {
      key: "total_items",
      label: i18n.t('Items'),
      sortable: true,
      tdClass: 'total-items-col',
      isVisible: true,
      expand: ''
    },
    {key: "status", label: i18n.t('Status'), sortable: true, tdClass: 'status-col', isVisible: true, expand: ''},
    {
      key: "last_synced_at",
      label: i18n.t('Synced At'),
      sortable: true,
      tdClass: 'synced-at-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "actions",
      label: i18n.t('Actions'),
      sortable: false,
      tdClass: 'actions-col',
      isVisible: true,
      expand: 'total_notes',
      exclude_from_export: true
    },
    {
      key: 'created_data',
      label: i18n.t('Created at / Created by'),
      sortable: false,
      tdClass: 'created-data-col',
      isVisible: false,
      expand: 'created_by'
    },
    {
      key: 'updated_data',
      label: i18n.t('Updated at / Updated by'),
      sortable: false,
      tdClass: 'updated-data-col',
      isVisible: false,
      expand: 'updated_by'
    },
    {
      key: 'receipts',
      label: i18n.t('Receipts'),
      sortable: false,
      tdClass: 'receipts-data-col',
      isVisible: false,
      expand: 'receipts'
    },
    {
      key: 'contact_person_for_settlement',
      label: i18n.t('Related Customer'),
      sortable: false,
      tdClass: 'customer-uuid-col',
      isVisible: false,
      expand: 'contact_person_for_settlement'
    },
    {
      key: 'notification_sent_at',
      label: i18n.t('Settlement Notification Sent'),
      sortable: true,
      tdClass: 'settlement-notification-sent-col',
      isVisible: false,
      expand: 'contact_person_for_settlement'
    },
    {
      key: 'transaction_history',
      label: i18n.t('Transaction History'),
      sortable: true,
      tdClass: 'transaction_history-col',
      isVisible: false,
      expand: 'settlement_tr_history.financial_export.created_by,settlement_tr_history.created_by',
      exclude_from_export: true
    },
    {
      key: 'payment_history',
      label: i18n.t('Payment History'),
      sortable: true,
      tdClass: 'payment_history-col',
      isVisible: false,
      expand: '',
      exclude_from_export: true
    },
    {
      key: 'identity_verification',
      label: i18n.t('Identity Verification'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'customer.term'
    },
    {
      key: 'kyc_status_verification',
      label: i18n.t('Account/KYC Verification'),
      sortable: true,
      tdClass: '',
      isVisible: false,
      expand: 'customer.term'
    },
    {
      key: 'approved',
      label: i18n.t('Approved'),
      sortable: true,
      tdClass: 'approved-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'vendor_payment_method',
      label: i18n.t('Vendor Payment Method'),
      sortable: true,
      tdClass: 'vendor_payment_method-col',
      isVisible: false,
      expand: 'customer.term'
    },
    {
      key: "total_amount",
      label: i18n.t('Total'),
      sortable: true,
      tdClass: 'total-amount-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "paid_amount",
      label: i18n.t('Paid'),
      sortable: true,
      tdClass: 'paid-amount-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "outstanding_amount",
      label: i18n.t('Outstanding'),
      sortable: true,
      tdClass: 'outstanding-amount-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'debited_settlement',
      label: i18n.t('Associated Debited Settlement'),
      sortable: false,
      tdClass: 'debited_settlement-col',
      isVisible: false,
      expand: 'debited_settlement'
    },
    {
      key: 'debit_note',
      label: i18n.t('Associated Debit Note'),
      sortable: false,
      tdClass: 'debit_note-col',
      isVisible: false,
      expand: 'debit_note'
    },
    {
      key: 'vendor_group_account',
      label: i18n.t('Vendor Group Account'),
      sortable: false,
      isVisible: false,
      expand: 'auction'
    },
    {
      key: 'billing_address_1',
      label: i18n.t('Billing Address 1'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'settlement_billing_address'
    },
    {
      key: 'billing_address_2',
      label: i18n.t('Billing Address 2'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'settlement_billing_address'
    },
    {
      key: 'billing_state',
      label: i18n.t('Billing State'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'settlement_billing_address'
    },
    {
      key: 'billing_county',
      label: i18n.t('Billing County'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'settlement_billing_address.country'
    },
    {
      key: 'billing_city',
      label: i18n.t('Billing City'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'settlement_billing_address'
    },
    {
      key: 'billing_zip_code',
      label: i18n.t('Billing Zip/Post Code'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'settlement_billing_address'
    },
    {
      key: 'billing_country',
      label: i18n.t('Billing Country'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'settlement_billing_address.country'
    },
    {
      key: 'billing_first_name',
      label: i18n.t('Billing First Name'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'settlement_billing_address'
    },
    {
      key: 'billing_last_name',
      label: i18n.t('Billing Last Name'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'settlement_billing_address'
    },
    {
      key: 'client_tier',
      label: i18n.t('Client Tier'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'customer'
    },
    {key: 'date', label: i18n.t('Date'), sortable: true, tdClass: 'date-col', isVisible: false, expand: ''},
    {
      key: 'branch',
      label: i18n.t('Branch'),
      sortable: false,
      tdClass: '',
      isVisible: false,
      expand: 'branch'
    },
  ];
  const excludeFields = [];
  if (!hasPermission('view_customeridentification')) {
    excludeFields.push('identity_verification');
    excludeFields.push('kyc_status_verification');
  }
  if (excludeFields.length) {
    fields = fields.filter(f => !excludeFields.includes(f.key));
  }

  return fields
}

let getDefaultManualSettlementModal = () => {
  return {
    loading: false,
    show: false,
    object: null,
    source: null,
    customer: null,
    debitNoteWithoutRefundParams: null,
    unsavedCharges: [],
  }
}

let getDefaultIntroductorySettlementModal = () => {
  return {
    loading: false,
    show: false,
    object: null,
    sale: null,
    customer: null,
    source: null,
    type: null,
    debitNoteWithoutRefundParams: null,
  }
}

let getDefaultDebitNoteModal = () => {
  return {
    show: false,
    object: null,
    source: null,
  }
}

export default {
  namespaced: true,
  state: {
    tableSource: null,
    modal: {
      loading: false,
      show: false,
      object: null,
      sale: null,
      customer: null,
      source: null,
      disableCustomerInput: false,
      debitNoteWithoutRefundParams: null,
      unsavedCharges: [],
    },
    introductorySettlementModal: getDefaultIntroductorySettlementModal(),
    manualSettlementModal: getDefaultManualSettlementModal(),
    listModal: {
      loading: false,
      show: false,
      settlements: [],
      object: null,
      source: null,
      sale: null
    },
    generateBatchCheckModal: {
      show: false,
      source: null,
      selectedElements: []
    },
    generateBacsPaymentsModal: {
      show: false,
      source: null,
      selectedElements: []
    },
    paymentListModal: {
      show: false,
      source: null,
      settlement: {}
    },
    paymentModal: {
      show: false,
      type: 'payment',
      object: null,
      source: null,
      settlements: [],
    },
    tableData: {
      sale: getDefaultTableData(),
      customer: getDefaultTableData(),
      settlements: getDefaultTableData(),
    },
    transactionExportsModal: {
      show: false,
      source: null,
      settlement: null,
    },
    paymentExportsModal: {
      show: false,
      source: null,
      settlement: null,
    },
    debitNoteModal: getDefaultIntroductorySettlementModal(),
    addChargeModal: {
      settlement: null,
      applicableVendorCharges: [],
      show: false
    },
    settlementBatchPaymentModal: {
      show: false,
      loading: false,
      source: null,
      object: null
    }
  },
  actions: {
    initTableData({state}) {
      state.tableData = {
        sale: getDefaultTableData(),
        customer: getDefaultTableData(),
        settlements: getDefaultTableData(),
      }
      return true
    },
    resetSearchModel({commit}) {
      commit('resetSearchModel')
    },
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: `${SETTLEMENTS_TABLE_NAME}.${state.tableSource}`
      });

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          search: currentTableData.search,
          ordering: ordering,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      const defaultExpand = currentTableData.expand
      const expand = currentTableData.toggleColumns.fields
        .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',')

      data.expand = `${expand},${defaultExpand}`;

      return data;
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      EventBus.$emit(ON_SETTLEMENTS_TABLE_GET_TABLE_DATA, {params});
      commit('updateTableLoading', true);
      const response = await SettlementService.getSettlements(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }
      return response;
    },
    async updateTableSource({state}, {extraFilters, source, sale, customer = null}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
      state.tableData[source].sale = sale;
      state.tableData[source].customer = customer;
    },
    updateSearchModel({commit, state}, {searchModel, source = null}) {
      commit('updateSearchModel', {
        searchModel: new SettlementSearch({
          ...state.tableData[source || state.tableSource].searchModel,
          ...searchModel
        }),
        source
      });
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = {
        ...state.tableData[state.tableSource],
        ...defaultTableData
      };
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].extraFilters = extraFilters;

      dispatch('getTableData');
    },


    hideModal({commit}) {
      commit('hideModal');
    },
    showModal({commit}, {source, customer, sale, disableCustomerInput, debitNoteWithoutRefundParams} = {}) {
      commit('showModal', {source, customer, sale, disableCustomerInput, debitNoteWithoutRefundParams});
    },

    hideGenerateBatchCheckModal({commit}) {
      commit('hideGenerateBatchCheckModal');
    },
    showGenerateBatchCheckModal({commit}, {source, selectedElements}) {
      const ids = []
      selectedElements.forEach(el => ids.push(el.uuid))
      commit('showGenerateBatchCheckModal', {source, selectedElements: ids});
    },
    showGenerateBacsPaymentsModal({commit}, {source, selectedElements}) {
      const ids = []
      selectedElements.forEach(el => ids.push(el.uuid))
      commit('showGenerateBacsPaymentsModal', {source, selectedElements: ids});
    },
    hideGenerateBacsPaymentsModal({commit}) {
      commit('hideGenerateBacsPaymentsModal');
    },
    hideListModal({commit}) {
      commit('hideListModal');
    },
    showListModal({commit}, {source, sale} = {}) {
      commit('showListModal', {source, sale: _.cloneDeep(sale)});
    },
    async getModalData({commit}, {params, object, sale, customer, removeOldData=false}) {
      commit('updateModalLoading', true);
      let response = await SettlementService.getVendorData(params);
      commit('updateModalLoading', false);
      if (response.success) {
        if (store.state.global.enableContinuousAuction) {
          object.lot = response.body.financial_items[0].lot;
          object.lot_uuid = object.lot.uuid;
        }

        commit('updateModalObjectItems', {
          object,
          financial_items: response.body.financial_items,
          receipts: response.body.receipts,
          responseBody: response.body,
          removeOldData: removeOldData
        })
        commit('updateModalObject', {sale, customer});
      }
      return response;
    },
    async createSettlement({dispatch}, data) {
      let response = await SettlementService.createSettlement(data);

      if (response.success) {
        dispatch('getTableData')
      }

      return response;
    },
    async cancelSettlement({dispatch}, uuid) {
      let response = await SettlementService.cancelSettlement(uuid, 'outstanding_amount,paid_amount');
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },

    showPaymentListModal({commit}, {source, settlement} = {}) {
      commit('showPaymentListModal', {settlement: _.cloneDeep(settlement), source});
    },
    hidePaymentListModal({commit}) {
      commit('hidePaymentListModal');
    },

    showPaymentModal({commit}, {object = null, source, settlements, type = 'payment'} = {}) {
      commit('showPaymentModal', {object: _.cloneDeep(object), settlements: _.cloneDeep(settlements), type, source});
    },
    updatePaymentModalObject({state}, {object}) {
      state.paymentModal.object = _.cloneDeep(object);
    },
    hidePaymentModal({commit}) {
      commit('hidePaymentModal');
    },
    updatePaymentListModalSettlement({state}) {
      let settlement = state.tableData[state.tableSource].rows.find(s => s.uuid === state.paymentListModal.settlement.uuid);
      if (settlement) {
        state.paymentListModal.settlement = settlement;
      }
      return true;
    },
    showManualSettlementModal({commit}, {object = null, customer = null, source, debitNoteWithoutRefundParams = null} = {}) {
      commit('showManualSettlementModal', {object: _.cloneDeep(object), source, customer, debitNoteWithoutRefundParams});
    },
    hideManualSettlementModal({commit}) {
      commit('hideManualSettlementModal');
    },
    async getManualSettlementModalData({commit}, {params, object, customer, removeOldData=false}) {
      commit('updateManualSettlementModalLoading', true);
      let response = await SettlementService.getVendorData(params);
      if (response.success) {
        commit('updateManualSettlementModalLoading', false);

        commit('updateModalObjectItems', {
          object,
          financial_items: response.body.financial_items,
          receipts: response.body.receipts,
          objSource: 'manualSettlementModal',
          responseBody: response.body,
          removeOldData: removeOldData
        })
        commit('updateManualSettlementModalObject', {customer});
      }
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
    hideIntroductorySettlementModal({commit}) {
      commit('hideIntroductorySettlementModal');
    },
    showIntroductorySettlementModal({commit}, {source, customer, type, sale = null, debitNoteWithoutRefundParams = null} = {}) {
      commit('showIntroductorySettlementModal', {source, customer, type, sale, debitNoteWithoutRefundParams});
    },
    async getIntroductorySettlementModalData({state}, {object: settlement, removeOldData}) {
      state.introductorySettlementModal.loading = true
      let settlementResponse = await SettlementService.getSettlement(settlement.uuid, {
        expand: 'customer,settlement_billing_address.country,auction.currency,currency'
      });

      settlement = settlementResponse.body;
      if (removeOldData) {
        delete settlement.created_at;
        delete settlement.date;
        delete settlement.is_processed;
        delete settlement.is_not_editable;
        delete settlement.is_legacy;
      }

      let response;
      if (settlement.type === 'auction_introductory') {
        state.introductorySettlementModal.sale = settlement.auction
        response = await SettlementService.getAllFinancialItemsByCustomerForAuction(settlement.customer_uuid, settlement.auction_uuid, 'lot.inventory,settlement');
      } else {
        response = await SettlementService.getAllFinancialItemsByCustomerForManual(settlement.customer_uuid, 'inventory,settlement');
      }

      if (response.success) {
        let introductory_financial_items = response.body.results
          .filter(i => i.introductory_commission > 0 && (i.introductory_settlement_uuid === settlement.uuid || !i.introductory_settlement_uuid));
        state.introductorySettlementModal.object = {
          ...settlement,
          introductory_financial_items: introductory_financial_items,
        }
      }

      state.introductorySettlementModal.loading = false
    },
    showDebitNoteModal({commit}, {object = null, source} = {}) {
      commit('showDebitNoteModal', {object: _.cloneDeep(object), source});
    },
    hideDebitNoteModal({commit}) {
      commit('hideDebitNoteModal');
    },
    async getDebitNoteSettlementModalObject({commit}, {settlement}) {
      let expand = 'customer.billing_address.country,';

      if (settlement.type === SETTLEMENT_TYPE_DEBIT_NOTE) {
        expand += 'debited_settlement.currency,debited_settlement.total_amount,debited_settlement.outstanding_amount,' +
          'debited_settlement.paid_amount,debited_settlement.customer.billing_address.country,';
        if (settlement.debited_settlement.type === SETTLEMENT_TYPE_AUCTION || settlement.debited_settlement.type === SETTLEMENT_TYPE_AUCTION_INTRODUCTORY) {
          expand += 'debited_settlement.debited_financial_items.lot.inventory';
        } else if (settlement.debited_settlement.type === SETTLEMENT_TYPE_MANUAL || settlement.debited_settlement.type === SETTLEMENT_TYPE_MANUAL_INTRODUCTORY) {
          expand += 'debited_settlement.debited_financial_items.inventory';
        }
      } else {
        expand += 'currency,total_amount,outstanding_amount,auction,';
        if (settlement.type === SETTLEMENT_TYPE_AUCTION) {
          expand += 'financial_items.lot.inventory,financial_items.vendor_total';
        } else if (settlement.type === SETTLEMENT_TYPE_AUCTION_INTRODUCTORY) {
          expand += 'introductory_financial_items.lot.inventory'
        } else if (settlement.type === SETTLEMENT_TYPE_MANUAL) {
          expand += 'financial_items.inventory,financial_items.vendor_total,';
        } else if (settlement.type === SETTLEMENT_TYPE_MANUAL_INTRODUCTORY) {
          expand += 'introductory_financial_items.inventory,';
        }
      }

      let response = await SettlementService.getSettlement(settlement.uuid, {expand});
      if (response.success) {
        commit('getDebitNoteSettlementModalObject', {object: response.body});
      }

      return response;
    },
    async createDebitNote({dispatch}, params) {
      const response = await SettlementService.createDebitNote(params);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    async updateDebitNote({dispatch}, params) {
      const response = SettlementService.updateDebitNote(params);
      if (response.success) {
        dispatch('getTableData');
      }
      return response;
    },
    async showTransactionExportsModal({commit}, {settlement = null, source} = {}) {
      commit('showTransactionExportsModal', {settlement: _.cloneDeep(settlement), source});
    },
    async hideTransactionExportsModal({commit}) {
      commit('hideTransactionExportsModal');
    },
    async showPaymentExportsModal({commit}, {settlement = null, source} = {}) {
      commit('showPaymentExportsModal', {settlement: _.cloneDeep(settlement), source});
    },
    async hidePaymentExportsModal({commit}) {
      commit('hidePaymentExportsModal');
    },
    hideAddChargeModal({commit}) {
      commit('hideAddChargeModal');
    },
    showAddChargeModal({commit}, {settlement, unsavedCharges, settlementModal, funcParams} = {}) {
      commit('showAddChargeModal', {settlement, unsavedCharges, settlementModal, funcParams});
    },
    addUnsavedCharges({commit}, {unsavedCharges}) {
      commit('addUnsavedCharges', {unsavedCharges});
    },


    showSettlementBatchPaymentModal({state}, {source}) {
      state.settlementBatchPaymentModal.show = true
      state.settlementBatchPaymentModal.source = source
    },
    hideSettlementBatchPaymentModal({state}) {
      state.settlementBatchPaymentModal.show = false
      state.settlementBatchPaymentModal.source = null
      state.settlementBatchPaymentModal.object = null
    },
    toggleSettlementBatchPaymentModalLoading({state}, val) {
      state.settlementBatchPaymentModal.loading = val
    },
    async getSettlementBatchPaymentModalObject({state}, batchPaymentUuid) {
      let response = await InvoicesService.getBatchPayment(batchPaymentUuid, {
        expand: [
          'payments.settlement_payments.settlement.currency',
          'payments.settlement_payments.settlement.payable_amount',
          'payments.settlement_payments.settlement.customer',
        ].join(',')
      })
      if (response.success) {
        state.settlementBatchPaymentModal.object = response.body
      }
    },

  },
  mutations: {
    async showGenerateBatchCheckModal(state, payload) {
      const {source, selectedElements} = payload

      state.generateBatchCheckModal.show = true
      state.generateBatchCheckModal.source = source
      state.generateBatchCheckModal.selectedElements = selectedElements
    },
    hideGenerateBatchCheckModal(state) {
      state.generateBatchCheckModal.show = false
      state.generateBatchCheckModal.source = null
      state.generateBatchCheckModal.selectedElements = null
    },
    async showGenerateBacsPaymentsModal(state, payload) {
      const {source, selectedElements} = payload

      state.generateBacsPaymentsModal.show = true
      state.generateBacsPaymentsModal.source = source
      state.generateBacsPaymentsModal.selectedElements = selectedElements
    },
    hideGenerateBacsPaymentsModal(state) {
      state.generateBacsPaymentsModal.show = false
      state.generateBacsPaymentsModal.source = null
      state.generateBacsPaymentsModal.selectedElements = null
    },
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {
      ...state.tableData[state.tableSource],
      ...payload
    },
    updateSearchModel: (state, {
      searchModel,
      source
    }) => state.tableData[source || state.tableSource].searchModel = searchModel,
    resetSearchModel: state => {
      state.tableData[state.tableSource].searchModel = new SettlementSearch()
    },

    hideModal: (state) => {
      state.modal.show = false;
      state.modal.sale = null;
      state.modal.object = null;
      state.modal.customer = null;
      state.modal.source = null;
      state.modal.disableCustomerInput = false;
      state.modal.financial_items = [];
      state.modal.miscellaneous_items = [];
    },
    showModal: (state, {source, customer = null, sale = null, disableCustomerInput = false, debitNoteWithoutRefundParams = null}) => {
      state.modal.show = true;
      state.modal.source = source;
      state.modal.customer = customer;
      state.modal.sale = sale;
      state.modal.disableCustomerInput = disableCustomerInput;
      state.modal.debitNoteWithoutRefundParams = debitNoteWithoutRefundParams;
    },
    updateModalObject: (state, {sale, customer}) => {
      state.modal.sale = sale;
      state.modal.customer = customer;
    },
    updateModalObjectItems: (state, {
      object,
      financial_items = [],
      receipts = [],
      objSource = 'modal',
      responseBody,
      removeOldData
    }) => {
      let responseSettlement = null;
      if (responseBody && responseBody.settlements) {
        responseSettlement = responseBody.settlements.find(s => s.uuid === object.uuid);
      }

      object.unsettled_financial_items = financial_items.filter(item => !item.settlement_uuid)
      object.financial_items = financial_items.filter(item => item.settlement_uuid && object.uuid === item.settlement_uuid)

      object.miscellaneous_items = responseSettlement ? responseSettlement.miscellaneous_items : [];

      object.settlement_billing_address = responseSettlement ? responseSettlement.settlement_billing_address : null

      if (responseSettlement) {
        object.settlement_charges = responseSettlement.settlement_charges || []
      }

      if (responseBody && responseBody.applicable_vendor_charges) {
        object.applicable_vendor_charges = responseBody.applicable_vendor_charges;
      }

      if (removeOldData) {
        delete object.created_at;
        delete object.date;
        delete object.is_processed;
        delete object.is_not_editable;
        delete object.is_legacy;
      }

      state[objSource].object = object;
    },
    updateModalLoading: (state, payload) => state.modal.loading = payload,
    hideListModal: state => {
      state.listModal.settlements = []
      state.listModal.object = null
      state.listModal.show = false
    },
    showListModal: (state, {source, sale}) => {
      state.listModal.show = true;
      state.listModal.source = source;
      state.listModal.sale = sale;
    },

    showPaymentListModal: (state, {source, settlement}) => {
      state.paymentListModal.show = true;
      state.paymentListModal.source = source;
      state.paymentListModal.settlement = settlement;
    },
    hidePaymentListModal: state => state.paymentListModal.show = false,
    showPaymentModal: (state, {object, source, type, settlements}) => {
      state.paymentModal.show = true;
      state.paymentModal.object = object;
      state.paymentModal.source = source;
      state.paymentModal.type = type;
      state.paymentModal.settlements = settlements;
    },
    hidePaymentModal: state => state.paymentModal.show = false,
    updateManualSettlementModalLoading: (state, payload) => state.manualSettlementModal.loading = payload,
    showManualSettlementModal: (state, {object, source, customer, debitNoteWithoutRefundParams}) => {
      state.manualSettlementModal.show = true;
      state.manualSettlementModal.object = object;
      state.manualSettlementModal.source = source;
      state.manualSettlementModal.customer = customer;
      state.manualSettlementModal.debitNoteWithoutRefundParams = debitNoteWithoutRefundParams;
    },
    hideManualSettlementModal: state => state.manualSettlementModal = getDefaultManualSettlementModal(),
    updateManualSettlementModalObject: (state, {customer}) => state.manualSettlementModal.customer = customer,
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
    hideIntroductorySettlementModal: (state) => {
      state.introductorySettlementModal = getDefaultIntroductorySettlementModal()
    },
    showIntroductorySettlementModal: (state, {source, customer = null, type = null, sale, debitNoteWithoutRefundParams}) => {
      state.introductorySettlementModal.show = true;
      state.introductorySettlementModal.source = source;
      state.introductorySettlementModal.customer = customer;
      state.introductorySettlementModal.type = type;
      state.introductorySettlementModal.sale = sale;
      state.introductorySettlementModal.debitNoteWithoutRefundParams = debitNoteWithoutRefundParams;
    },
    showDebitNoteModal: (state, {object, source}) => {
      state.debitNoteModal.show = true;
      state.debitNoteModal.object = object;
      state.debitNoteModal.source = source;
    },
    hideDebitNoteModal: state => {
      state.debitNoteModal = getDefaultDebitNoteModal();
    },
    getDebitNoteSettlementModalObject: (state, {object}) => {
      state.debitNoteModal.object = object;
    },
    showTransactionExportsModal: (state, {source, settlement}) => {
      state.transactionExportsModal.show = true
      state.transactionExportsModal.source = source
      state.transactionExportsModal.settlement = settlement
    },
    hideTransactionExportsModal: (state) => {
      state.transactionExportsModal.show = false
      state.transactionExportsModal.source = null
      state.transactionExportsModal.settlement = null
    },
    showPaymentExportsModal: (state, {source, settlement}) => {
      state.paymentExportsModal.show = true
      state.paymentExportsModal.source = source
      state.paymentExportsModal.settlement = settlement
    },
    hidePaymentExportsModal: (state) => {
      state.paymentExportsModal.show = false
      state.paymentExportsModal.source = null
      state.paymentExportsModal.settlement = null
    },
    hideAddChargeModal: (state) => {
      state.addChargeModal.show = false;
      state.addChargeModal.settlement = null;
      state.addChargeModal.applicableVendorCharges = [];
    },
    showAddChargeModal: (state, {settlement, unsavedCharges, settlementModal, funcParams}) => {
      state.addChargeModal.settlement = settlement;
      state.addChargeModal.unsavedCharges = unsavedCharges;
      state.addChargeModal.settlementModal = settlementModal;
      state.addChargeModal.show = true;
      state.addChargeModal.funcParams = funcParams;
    },
    addUnsavedCharges: (state, {unsavedCharges}) => {
      state.modal.unsavedCharges = [...state.modal.unsavedCharges, ...unsavedCharges];
    }
  }
}
